import getRandomInt from "../helpers/getRandomInt";

export default {
  namespaced: true,
  state: {
    draft: null
  },
  mutations: {
    setDraft(state, payload) {
      state.draft = payload;
    }
  },
  actions: {
    async getOrdersDraft({ commit }) {
      const res = await this._vm.$http("get", "orders/draft");
      if (res.status === 200) {
        commit("setDraft", res.result.order);
      }
    },
    async notifyAddCart({ dispatch }) {
      dispatch("setSnackBar", { msg: this._vm.$t("added_to_cart")[getRandomInt(0, this._vm.$t("added_to_cart").length)], color: "green" }, { root: true });
      dispatch("snackOn", {}, { root: true });
    },
    async notifyPurchaceComplete({ dispatch }) {
      dispatch("setSnackBar", { msg: this._vm.$t("complete_purchace"), color: "green" }, { root: true });
      dispatch("snackOn", {}, { root: true });
    },
    async notifyAddToCartError({ dispatch }) {
      dispatch("setSnackBar", { msg: this._vm.$t("add_to_cart_error"), color: "red" }, { root: true });
      dispatch("snackOn", {}, { root: true });
    },
    async notifyUnbuyableAreaError({ dispatch }) {
      dispatch("setSnackBar", { msg: this._vm.$t("unbuyable_area_error"), color: "red" }, { root: true });
      dispatch("snackOn", {}, { root: true });
    },
    async notifyPurchaseError({ dispatch }) {
      dispatch("setSnackBar", { msg: this._vm.$t("purchase_error"), color: "red" }, { root: true });
      dispatch("snackOn", {}, { root: true });
    },
    async notifyPurchaseUnbuyableAreaError({ dispatch }, specie_list) {
      const error_msg = specie_list.join(", ") + this._vm.$t("purchase_unbuyable_area_error");
      dispatch("setSnackBar", { msg: error_msg, color: "red" }, { root: true });
      dispatch("snackOn", {}, { root: true });
    },
    async notifyChangeCountError({ dispatch }) {
      dispatch("setSnackBar", { msg: this._vm.$t("change_count_error"), color: "red" }, { root: true });
      dispatch("snackOn", {}, { root: true });
    },
    async changeLocation({ state, commit }, location_id) {
      const res = await this._vm.$http("put", "orders/draft", { order: { location_id } });

      if (res.status === 200) {
        const newState = {
          ...state.draft,
          location: { ...state.draft.location, id: location_id }
        };

        commit("setDraft", newState);
      }
    },
    async changeCount({ state, commit }, { id, count, flowerHarvestId }) {
      const data = {
        order_item: { count }
      };

      if (flowerHarvestId) {
        data.order_item.flower_harvest_id = flowerHarvestId;
      }

      console.log("[Body]...", data);

      const res = await this._vm.$http("put", `order_items/${id}`, data);

      if (res.status === 200) {
        const newDraft = { ...state.draft };
        const idx = newDraft.order_items.findIndex(x => x.id === id);
        newDraft.order_items[idx].count = count;
        newDraft.order_items[idx].price = count * newDraft.order_items[idx].flower_harvest.sales_price;

        newDraft.normal_order_total_price = newDraft.order_items.reduce((order_item, obj) => {
          if (!order_item.price) order_item.price = [];
          if (order_item.order_item_type !== "request") order_item.price.push(obj.price);
          return order_item;
        }, {}).price[0];

        newDraft.request_order_total_price = newDraft.order_items.reduce((order_item, obj) => {
          if (!order_item.price) order_item.price = [];
          if (order_item.order_item_type === "request") order_item.price.push(obj.price);
          return order_item;
        }, {}).price[0];

        newDraft.total_price = newDraft.order_items.reduce((order_item, obj) => {
          if (!order_item.price) order_item.price = [];
          order_item.price.push(obj.price);
          return order_item;
        }, {}).price[0];

        commit("setDraft", newDraft);
      }

      return res.status;
    }
  },
  getters: {
    draftCount(state) {
      return state.draft ? state.draft.order_items.length : 0;
    }
  }
};
